import React from "react";
import packageJson from "../package.json";

class CacheBuster extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            isLatestVersion: false,
            refreshCacheAndReload: () => {
                console.log("Clearing cache and hard reloading...");
                try {
                    caches.keys().then(async function(names) {
                        await Promise.all(names.map(name => caches.delete(name)));
                    });
                    
                    window.location.reload(true);
                } catch (error) {
                    console.log("Cache busting error occured", error);
                }
            }
        };
    }

    componentDidMount() {
        const storedAppVersion = localStorage.getItem("appVersion");
        if (!storedAppVersion) {
            localStorage.setItem("appVersion", packageJson.version);
            this.setState({loading: false, isLatestVersion: false});
        } else {
            const latestVersion = storedAppVersion;
            const currentVersion = packageJson.version;

            const shouldForceRefresh = latestVersion != currentVersion;
            if (shouldForceRefresh) {
                console.log(`We have a new version - ${latestVersion}. Should force refresh`);
                localStorage.setItem("appVersion", packageJson.version);
                this.setState({loading: false, isLatestVersion: false});
            } else {
                process.env.NODE_ENV != "production" && console.log(
                    `You already have the latest version - ${latestVersion}. No cache refresh needed.`
                ); 
                this.setState({loading: false, isLatestVersion: true});
            }
        }
    }

    render() {
        const {loading, isLatestVersion, refreshCacheAndReload} = this.state;
        return this.props.children({loading, isLatestVersion, refreshCacheAndReload});
    }
}

export default CacheBuster;
